import React, { createRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import gsap from 'gsap';
import { Icon } from '../';
import { useDidMount } from '../../../helpers';
const Wrapper = styled.div `
  --mailbox-flag-rotate: 0deg;
  --mailbox-counter-scale: 0;

  ${({ counter }) => counter > 0 &&
    css `
      --mailbox-counter-scale: 1;
    `}

  position: relative;
  display: table;

  svg {
    --icon-size: 30px;
    --icon-color: ${({ theme }) => theme.primary.background};

    g g {
      transform-origin: 53.5% 50%;
      transform: rotate(var(--mailbox-flag-rotate));
    }
  }
`;
const Counter = styled.div `
  position: absolute;
  bottom: 0;
  right: -22%;
  width: 15px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  font-size: 11px;
  font-weight: bold;
  box-shadow: 0 0 0 2px var(--icon-background, ${({ theme }) => theme.background});
  border-radius: 50%;
  background-color: var(--icon-color, ${({ theme }) => theme.primary.background});
  transform: scale(var(--mailbox-counter-scale)) translateZ(0);
  color: var(--icon-color-foreground, ${({ theme }) => theme.primary.foreground});
`;
export const IconMailbox = (props) => {
    const wrapperRef = createRef();
    const didMount = useDidMount();
    const count = props.counter ?? 0;
    useEffect(() => {
        const wrapperElem = wrapperRef.current;
        if (!didMount || !wrapperElem) {
            return;
        }
        if (!props.counter || props.counter < 0) {
            gsap.to(wrapperElem, {
                '--mailbox-flag-rotate': '0deg',
                duration: 0.4,
                ease: 'elastic.out(1, .75)',
            });
            gsap.to(wrapperElem, {
                '--mailbox-counter-scale': 0,
                duration: 0.2,
            });
            return;
        }
        gsap.to(wrapperElem, {
            '--mailbox-flag-rotate': '-90deg',
            duration: 0.4,
            ease: 'elastic.out(1, .75)',
        });
        gsap.to(wrapperElem, {
            keyframes: [
                {
                    '--mailbox-counter-scale': 1.2,
                    duration: 0.1,
                },
                {
                    '--mailbox-counter-scale': 0.9,
                    duration: 0.1,
                },
                {
                    '--mailbox-counter-scale': 1,
                    duration: 0.2,
                },
            ],
        });
    }, [props.counter]);
    return (React.createElement(Wrapper, { className: props.className, counter: count, ref: wrapperRef },
        React.createElement(Icon.MailboxEmpty, null),
        React.createElement(Counter, null, count)));
};
//# sourceMappingURL=Mailbox.js.map